$('.search form[action="/search"]').submit(function (event) {
          	var self = this;
          	event.preventDefault ? event.preventDefault() : event.returnValue = false;
          
            var searchfield = $('.search form[action="/search"] input[type="text"]');
          	var words = $(searchfield).val().split(" ");
          
            $(searchfield).val('');
          
            $.each(words, function(i, v) {
                $(searchfield).val($(searchfield).val() + '*' + v + '* ');
            });
          
          	self.submit();
  			
        });

$('.wrapper-search-bar form[action="/search"]').submit(function (event) {
          	var self = this;
          	event.preventDefault ? event.preventDefault() : event.returnValue = false;
          
            var searchfield = $('.wrapper-search-bar form[action="/search"] input[type="text"]');
          	var words = $(searchfield).val().split(" ");
          
            $(searchfield).val('');
          
            $.each(words, function(i, v) {
                $(searchfield).val($(searchfield).val() + '*' + v + '* ');
            });
          
          	self.submit();
  
        });